import useDB from "../../hooks/useDB";
import { Link, useParams } from "react-router-dom";
import Loading from "../../components/Loading";
import Error from "../../components/Error";
import { useState } from "react";
import SelectFromList from "../../components/SelectFromList";


export default function SyllabusMissing() {
    const {id} = useParams()

    const [syllabus, , error, loading] = useDB(`/get-syllabus-with-lessons/${id}`)
    const [filter,setFilter] = useState("")

if(loading) return <Loading />
if (error) return <Error />
    
  
    
    return (
      <div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <h2>{syllabus.name}</h2>
          </div>

          <SelectFromList
            choices={choices}
            value={filter}
            setValue={setFilter}
            none
            label="Filter by missing"
            style={{ width: 200, marginBottom: 10 }}
          />
        </div>
        {syllabus.units.map((unit) => (
          <DrawUnit
            key={unit._id}
            unit={unit}
            filter={filter}
          />
        ))}
      </div>
    );
}

function DrawUnit({ unit, filter }) {
    let color = "#f00";
    if (unit.percentComplete > 50) color = "#c79800";
    if (unit.percentComplete > 99) color = "#4ad106";
    return (
      <div style={{ marginTop: 10, marginBottom: 10 }}>
        <Link
          to={`/teaching/syllabus/${unit.syllabus}/unit/${unit._id}`}
          className="neat"
          style={{ fontWeight: "bold", marginTop: 10, marginBottom: 10, color }}
        >
          {unit.name} {unit.percentComplete}% complete
          {!unit.noTest && unit.tests.length === 0 && ", No test"}
        </Link>

        {unit.lessons.map((lesson) => (
          <DrawLesson
            lesson={lesson}
            filter={filter}
          />
        ))}
      </div>
    );
}

function DrawLesson({ lesson,filter }) {

 
    let missing = []
    if (!lesson.name) {
        missing.push("Name")
    }
    if (!lesson.description) {
        missing.push("Description")
    }
    if(!lesson.homework) {
        missing.push("Homework")
    }
    if (!lesson.modelLessonPlan || lesson.modelLessonPlan.length === 0) {
      missing.push("Model lesson plan");
    }
    if (!lesson.videos || lesson.videos.length === 0) {
        missing.push("Videos")
    }
    if (!lesson.ppts || lesson.ppts.length === 0) {
        missing.push("PPTs")
    }
    if(filter && !missing.includes(filter)) return null
    return (
      <div>
        <Link
          to={`/teaching/syllabus/${lesson.syllabus}/unit/${lesson.unit}/lesson/${lesson._id}`}
          className="neat"
        >
          <div style={{display:"flex", justifyContent: "space-between"}}>
            <div>{lesson.name}</div>
            <div> {missing.toString()}</div>
          </div>
        </Link>
      </div>
    );
}

const choices = [{
    name: "Name", _id: "Name"
}, {
    name: "Description", _id: "Description" 
},{
    name: "Homework", _id: "Homework"
}, {
    name: "Model Lesson Plan", _id: "Model lesson plan"
}, {
    name: "Videos", _id: "Videos"
    },
    {
        name: "Powerpoints", _id: "PPTs"
    }
    
]